import React, {useModal} from "../context/ModalContext";
//import AModal from "./AModal";
//import BModal from "./BModal";
import SigninModal from "./SigninModal";
import SignupModal from "./SignupModal";
import CustomerModal from "./CustomerModal";

const MODAL_COMPONENTS = {
  SIGNIN: SigninModal,
  SIGNUP: SignupModal,
  CUSTOMER: CustomerModal,
};

export default function ModalManager() {
  const { currentModal, closeModal } = useModal();
  const { name, props } = currentModal;
  if (!currentModal?.name) return null;

  
  const SelectedModal = MODAL_COMPONENTS[currentModal.name];
   if (!SelectedModal) {
    console.error("Unknown modal:", currentModal.name);
    return null;
  }
  return <SelectedModal isOpen onClose={closeModal}{...props} />;
}